import * as React from "react";
import { cx } from "../../utils/dom";
import { PositionType } from "../../utils/theme";
import { AsProps } from "../../utils/types";

export interface BoxProps {
  stretchX?: boolean;
  stretchY?: boolean;
  stretchXY?: boolean;
  position?: PositionType;
}

export const _Box = <T extends React.ElementType = "div">(
  {
    stretchX,
    stretchY,
    stretchXY,
    children,
    className,
    position,
    as = "div",
    ...props
  }: React.PropsWithChildren<BoxProps> & AsProps<T>,
  ref: React.Ref<T>
) => {
  const Comp = as;
  return (
    <Comp
      className={cx({
        [`position-${position}`]: !!position,
        "stretch-x": !!stretchX,
        "stretch-y": !!stretchY,
        "stretch-xy": !!stretchXY,
        [`${className}`]: !!className,
      })}
      ref={ref}
      {...props}
    >
      {children}
    </Comp>
  );
};

_Box.displayName = "Box";

export const Box = React.forwardRef(_Box) as typeof _Box;
